import { render, staticRenderFns } from "./TechnicalMessage.vue?vue&type=template&id=02b5de8f&scoped=true&"
import script from "./TechnicalMessage.vue?vue&type=script&lang=js&"
export * from "./TechnicalMessage.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalMessage.vue?vue&type=style&index=0&id=02b5de8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5de8f",
  null
  
)

export default component.exports
import {QCard,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon})
